import { Frame, Loading } from "@shopify/polaris";

export default function LoadingFrame() {
  return (
    <Frame>
      <Loading />
    </Frame>
  );
}
